import React from "react";
import * as LucideIcons from "lucide-react";

export const CURATED_ICONS = [
    "Bot", "Lightbulb", "Compass", "Route", "Globe", "GraduationCap", "BookOpen", "Award", "CalendarCheck", "Briefcase",
    "HeartHandshake", "Brain", "Smile", "Stethoscope", "ShieldCheck", "LifeBuoy", "Accessibility", "Scale", "BadgeEuro", "TreePine"
];

export const CURATED_COLORS = [
    "#3531AC", "#386DF3", "#007bff", "#9EA5F8",
    "#007A66", "#98D8C8", "#c7f0d2",
    "#F1CC72", "#F79151", "#ED5B3A", "#FF7477",
    "#FEBACF", "#FD779F", "#6A4C93",
];

export const renderIcon = (icon, size) => {
    if (icon) {
        const IconComponent = LucideIcons[icon];
        if (IconComponent) {
            return <IconComponent size={size} />;
        }
    }
    return <LucideIcons.Bot size={size} />;
};
